import { render } from "./MdlEnviarPlantillaInicioWhatsapp.vue?vue&type=template&id=3a0bec97&scoped=true"
import script from "./MdlEnviarPlantillaInicioWhatsapp.vue?vue&type=script&lang=js"
export * from "./MdlEnviarPlantillaInicioWhatsapp.vue?vue&type=script&lang=js"

import "./MdlEnviarPlantillaInicioWhatsapp.vue?vue&type=style&index=0&id=3a0bec97&scoped=true&lang=css"

import exportComponent from "/var/www/adm3.argusblack/adm3.argusblack/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a0bec97"]])

export default __exports__